import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { FunctionComponent } from 'react';

type TruckMovingProps = {
    className?: string;
};

const TruckMoving: FunctionComponent<TruckMovingProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'truck-moving'}
            viewBox="0 0 518 518"
        >
            <path d="M467.6 235.5c.2-1.2 3.5-28.7-23.1-59.3l-2-2.3H390v68h76.8l.8-6.4zm-63.9-8.5v-38.4h32.8c13.3 16.2 16.7 30.6 17.5 38.4h-50.3z" />
            <path d="M412.8 355.1c-22.6 0-41.1 18.9-41.1 42.2 0 23.3 18.4 42.2 41.1 42.2 22.6 0 41.1-18.9 41.1-42.2-.1-23.3-18.5-42.2-41.1-42.2zm0 54.2c-6.5 0-11.7-5.4-11.7-12.1 0-6.7 5.3-12.1 11.7-12.1s11.7 5.4 11.7 12.1c0 6.7-5.3 12.1-11.7 12.1z" />
            <path d="M120.8 355.1c-22.6 0-41.1 18.9-41.1 42.2 0 23.3 18.4 42.2 41.1 42.2 22.6 0 41.1-18.9 41.1-42.2-.1-23.3-18.5-42.2-41.1-42.2zm0 54.2c-6.5 0-11.7-5.4-11.7-12.1 0-6.7 5.3-12.1 11.7-12.1 6.5 0 11.7 5.4 11.7 12.1 0 6.7-5.2 12.1-11.7 12.1z" />
            <path d="M501.9 313.3v-99.8l-15.4-42c-8.6-24.4-31.9-30.2-43.2-29.9h-80.6v14.1h80.9c.9 0 22.4-.3 29.7 20.5l14.6 39.8v102.8l2 2c.1.1 9.7 10.4 9.7 23.9v34.2c0 .1-.1 6.6-4.5 8.4h-10.4c-1.1-6.4-3.7-16.5-9.6-26.6-8.8-15.3-26.8-33.6-62.2-33.7-2.6-.2-16.2-.8-31.4 6.1-24.9 11.4-36.3 34.7-41.5 54.2H193.8c-2.1-6.3-6.5-17.1-14.2-28-11.8-16.5-27.1-27-44.9-30.8h228V76.6H3.5v251.9h22.3v72.8h36.5l.9-5.9c8.5-53.4 51.2-54.4 53-54.4h.2c21.1-.7 38.4 8 51.5 26.1 10.1 14 13.8 28.7 13.8 28.8l1.3 5.4h168.3l1.2-5.5c12.8-58.5 57.5-55 59.4-54.8h.7c55 0 58.8 51.5 58.9 53.7l.4 6.6H497l.9-.2c12.4-3.2 15.7-15.9 15.7-22.2v-34.2c.1-15-7.8-26.7-11.7-31.4zM17.1 90.7H349v223.8H17.1V90.7zm33.3 296.5H39.8v-58.7h64.6c-5.1 1.2-11.4 3.2-18 6.8-13 7.2-29.5 22-36 51.9z" />
        </svg>
    );
};
export default TruckMoving;
